import { Pass, Seq, Cont, Dep, setObjectValue, DoDangerousAction } from "../../framework/Processes";
import { Application, External } from "../../framework/comp/Lambda/Constructors";
import { FunctionType } from "../../framework/comp/Types";
import MultivariateFunction from "../../framework/comp/EInstances/MultivariateFunction";

let RunMinigameProcess, RunAtomicTask;
import("./RunMinigameProcess").then(val => { RunMinigameProcess = val.default; RunAtomicTask = val.RunAtomicTask }).catch(val => console.error(val));

/**
 * Constructor of process produces a menu array as form and continues as RunMinigameProcess.
 * @param {[{ name: string, title: string }]} menu - menu array
 * @param runningProcess - process running in parallel
 */
function AdviceProcess(form, runningProcess, state) {
	return Cont("Player", form, External(function(adviceResponse) {
        let adviceRecord = {
            adviseId: adviceResponse.adviceId,
            minigame: {name: form.name},
            score: adviceResponse.score,
            maxScore: 0
        }
		return Seq([
			setObjectValue("history", adviceRecord, [state.objects.history.length]),
			runningProcess,
		]);
	}, "Function", FunctionType("Object", "Process")));
}
export default AdviceProcess;